import { render, staticRenderFns } from "./WorkDocs.vue?vue&type=template&id=640be43d&scoped=true"
import script from "./WorkDocs.vue?vue&type=script&lang=js"
export * from "./WorkDocs.vue?vue&type=script&lang=js"
import style0 from "./WorkDocs.vue?vue&type=style&index=0&id=640be43d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640be43d",
  null
  
)

export default component.exports